import AppConstant from '../../../config/app.constants';
import _ from 'lodash';

class ResetAtmCodeAllController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $location, SetupService, RouteService, $q, DateUtil, ResetAtmCodeService) {
        this.loading = true
        this.$location = $location;
        this.$translate = $translate;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.RouteService = RouteService;
        this.$q = $q;
        this.DateUtil = DateUtil;
        this.User = User;
        this.ResetAtmCodeService = ResetAtmCodeService;

        this.model = {
            vaultDate: '',
            allRoutes: [],
            branch: this.User.getUser().branchId,
            allAtmCodes: []
        };

        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        }

        this.routeList = [];
        this.totalRecord = 0;
        this.keys = "ATMCodes:*";
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.branch),
            this.loadRoutes('', 0)
            // this.getAtmCodeFromRedis()
        ])
            .then((data) => {
                const date = this.DateUtil.convertToDate(data[0].currentVaultDate);
                this.model.date = date;
                this.vaultDate = moment(this.model.date).format('YYYY-MM-DD');
                this.minVaultDate = {
                    minDate: this.valutDate
                }
            })
    }

    loadRoutes(searchKey, offset) {

        searchKey = searchKey || '';

        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branch
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "name",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: 'AND'
            }
        };

        this.RouteService.all(searchObj, offset, this.pagination.pageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.totalRecord = data.total;
                    this.routeList = this.mapData(data.results);
                } else {
                    const routes = this.mapData(data.results);
                    this.routeList = this.routeList.concat(routes)
                }
            })
            .catch((err) => {
                console.log(err);
            })
    }

    mapData(routes) {
        return routes.map((route) => {
            return {
                Key: route.id + ' | ' + route.name,
                Value: route.id
            }
        });
    }

    getAtmCodeFromRedis() {

        if (!this.model.route) {
            return this.model.allAtmCodes = [];
        }

        this.model.allAtmCodes = [];
        this.model.loading = true;
        let prefix = '',
            key = '',
            formattedDate = '';

        // if (this.model.route) {
            prefix = 'ATMCodes:';
            key = prefix.concat(this.model.route.Value, ':*');
            formattedDate = moment(this.model.date).format('MM-DD-YYYY');
        // }
        // else {
        //     key = this.keys;
        // }

        this.ResetAtmCodeService.getAllKeys(key, formattedDate)
            .then((res) => {
                this.model.allAtmCodes = res.results;
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.model.loading = false;
            })
    }

    confirmDelete(key) {
        if (this.allowOnce) return;
        this.allowOnce = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('resetAtmCode.delete_message'),
            callback: (({
                modal,
                $scope
            }) => {
                this.allowOnce = true;
                this.delete(key, this.allowOnce);
                modal.close();
            }),
            negative: (({
                modal,
            }) => {
                this.allowOnce = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

    delete(key, allowOnce) {
        this.allowOnce = allowOnce;
        this.model.isDeleting = true
        this.ResetAtmCodeService.deleteAtmCode(key, this.model.branch)
            .then((res) => {
                setTimeout(() => {
                    this.getAtmCodeFromRedis(); // reload data after delete
                }, 1000)
            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                this.allowOnce = false;
                this.model.isDeleting = false;
            })
    }

    getAtmCode(cacheKey) {
        this.Modal.atmCodesInfoModal(cacheKey, ({ modal }) => {
            modal.close();
        }, ({ modal }) => {
            modal.close();
        })
    }

}

export default ResetAtmCodeAllController;



// WEBPACK FOOTER //
// ./client/app/components/reset_atm_code/all/reset_atm_code.all.controller.js